import { render, staticRenderFns } from "./LossReport.vue?vue&type=template&id=3657ade4"
import script from "./LossReport.vue?vue&type=script&lang=ts"
export * from "./LossReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports